<template>
    <div v-if="!loaded" role="main" class="spinner-box text-center">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Spinner",
    props: ['loaded']
}
</script>

<style>
.spinner-box {
    margin-top: 12em;
    color: #ffc107;
}
</style>